import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DisableWorkspaceNotificationsMutationVariables = Types.Exact<{
  input: Types.ToggleWorkspaceNotificationsInput;
}>;


export type DisableWorkspaceNotificationsMutation = { __typename?: 'Mutation', disableWorkspaceNotifications?: { __typename?: 'ToggleWorkspaceNotificationsPayload', workspace?: { __typename?: 'Workspace', id: string, projectNotificationsEnabled?: boolean | null } | null } | null };


export const DisableWorkspaceNotifications = /*#__PURE__*/ gql`
    mutation DisableWorkspaceNotifications($input: ToggleWorkspaceNotificationsInput!) {
  disableWorkspaceNotifications(input: $input) {
    workspace {
      id
      projectNotificationsEnabled
    }
  }
}
    ` as unknown as DocumentNode<DisableWorkspaceNotificationsMutation, DisableWorkspaceNotificationsMutationVariables>;

          

          export const useDisableWorkspaceNotificationsMutation = (options?:MutationHookOptions<DisableWorkspaceNotificationsMutation, DisableWorkspaceNotificationsMutationVariables>) => useMutation(DisableWorkspaceNotifications, options);
          

          export type DisableWorkspaceNotificationsMutationOptions = MutationHookOptions<DisableWorkspaceNotificationsMutation, DisableWorkspaceNotificationsMutationVariables>;

          

          export type DisableWorkspaceNotificationsMutationResult = ReturnType<typeof useDisableWorkspaceNotificationsMutation>[1];

          
